package com.ervasstudio.tracoemovimento.pages.home

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

@Composable
fun TracoEMovimentoSectionDesktop() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .position(Position.Relative)
            .padding(top = 30.px, bottom = 50.px, left = 100.px, right = 60.px)
    ) {
        Image(
            src = "/seta_glow.png",
            modifier = Modifier.position(Position.Absolute).top(10.px).right(170.px).width(280.px)
        )
        Image(
            src = "/xish.png",
            modifier = Modifier.position(Position.Absolute).bottom(40.px).left(80.px).width(280.px)
        )

        Column(
            modifier = Modifier.fillMaxSize().padding(top = 150.px, bottom = 130.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                "TRAÇO",
                modifier = Modifier.fontSize(160.px).fontFamily("Gotham")
                    .fontWeight(FontWeight.Black).color(Colors.Black)
            )
            SpanText(
                "E MOVIMENTO",
                modifier = Modifier.fontSize(160.px).fontFamily("Gotham")
                    .fontWeight(FontWeight.Black).margin(top = (-20).px).color(Colors.Black)
            )
            SpanText(
                "O Traço e Movimento é um projeto desenvolvido pelo Ervas Studio. Nasce com a " +
                    "missão de formar uma nova geração de animadores, valorizando o traço africano, o " +
                    "olhar moçambicano e o poder do movimento como linguagem cultural.",
                modifier = Modifier.display(DisplayStyle.Block).textAlign(TextAlign.Justify)
                    .fontSize(27.px).fontFamily("museomoderno").fontWeight(FontWeight.Light)
                    .width(74.cssRem).margin(top = 20.px, bottom = 10.px).color(Colors.Black)
            )
            SpanText(
                text = "Através de cursos, laboratórios e experimentação visual" +
                    "o projecto cria um espaço onde jovens artistas podem " +
                    "aprender, praticar e transformar ideias em animação " +
                    "com identidade própria, rigor técnico e imaginação" +
                    " sem limites.",
                modifier = Modifier.fontSize(27.px).fontFamily("museomoderno").fontWeight(FontWeight.Light)
                    .width(74.cssRem).margin(bottom = 150.px).color(Colors.Black)
            )
            Row(modifier = Modifier.fillMaxWidth().height(30.px)) {}
        }
    }
}